<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="budgetdistributionlist"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		<add-index :currentrow="currentrow" ref="budgetdistributionaddIndex" @success="scoresubmit" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import addIndex from './add/index.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			currentrow: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '预算分配',
				modal_width: 1000,
				modal_height: 600,
				list_formConfig: [],
				// list_formConfig: [{
				// 	field: 'goodscode',
				// 	title: '产品编码',
				// 	itemRender: {
				// 		name: '$input'
				// 	}
				// }],
				list_footerField: [{
					field: 'budgetamount',
					toFixed: 4
				}, ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			add() {
				this.$refs.budgetdistributionaddIndex.modal_show()
			},
			del(e) {
				this.$confirm('是否确认删除').then(() => {
					this.$api.budget.deldistribution({
						id: e.id,
						budgetid:this.currentrow.id
					}).then(() => {
						this.$refs.budgetdistributionlist.commitProxy('query')
						this.$message.success('操作成功')
					})
				})
			},
			scoresubmit() {
				this.$refs.budgetdistributionlist.commitProxy('query')
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'objecttype',
						title: '对象类型',
					}, {
						field: 'objectid',
						title: '分配对象',
						formatter: ({
							row
						}) => {
							let target = null
							if (row.objecttype == '供应商') {
								target = window.systemData.supplier.find((item) => {
									return item.id == row.objectid
								})
							}
							if (row.objecttype == '部门') {
								target = window.systemData.department.find((item) => {
									return item.id == row.objectid
								})
							}
							return target ? target.name : null
						}

					}, {
						field: 'matter',
						title: '事项',
						formatter: ({
							row
						}) => {
							return window.systemMethods.getEmunValue('budgetmatter', row.matter)
						}
					}, {
						field: 'budgetamount',
						title: '预算金额',
					},
					{
						field: 'mark',
						title: '备注',
					},
					{
						field: 'staffid',
						title: '创建人',
						formatter: ({
							row
						}) => {
							return window.systemMethods.getstaff(row.staffid)
						}
					},
					{
						field: 'create_time',
						title: '创建时间',
						formatter: ({
							row
						}) => {
							return window.systemMethods.timestampToDate(row.create_time)
						}
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						slots: {
							default: ({
								row
							}) => {
								return [ <el-button size = "mini" type = "text" style = "color:#F56C6C;"
									onClick = {() => {this.del(row)}} > 删除 </el-button>,
								]
							}
						}
					},
				]
				gridOptions.pagerConfig.enabled = false
			},
			cancel(row) {
				this.$confirm('是否确认作废').then(() => {
					this.$api.supplier.cancelscore({
						id: row.id,
						supplierid: this.currentrow ? this.currentrow.id : null,
					}).then(() => {
						this.$refs.supplierscorelist.commitProxy('query')
					})
				})
			},
			list(page, updateForm, other) {
				return new Promise((resolve) => {
					this.$api.budget.listdistribution({
						budgetid: this.currentrow ? this.currentrow.id : null,
						...page,
						...updateForm,
						...other,
					}).then((res) => {
						resolve({
							list: res
						})
					}, () => {
						resolve([])
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			addIndex,

		}
	}
</script>